export default function IconUnMuite() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"      
    >
      <g id="SpeakerSimpleHigh">
        <g id="Vector">
          <path
            d="M19.4375 3.25497C19.2694 3.17359 19.082 3.14103 18.8964 3.16099C18.7109 3.18094 18.5346 3.2526 18.3875 3.36788L9.65 10.1798H4C3.46957 10.1798 2.96086 10.3912 2.58579 10.7677C2.21071 11.1441 2 11.6546 2 12.187V20.2157C2 20.748 2.21071 21.2586 2.58579 21.635C2.96086 22.0114 3.46957 22.2229 4 22.2229H9.65L18.3875 29.0348C18.5619 29.173 18.7777 29.2482 19 29.248C19.1513 29.2462 19.3004 29.212 19.4375 29.1477C19.6063 29.0653 19.7485 28.9369 19.848 28.7771C19.9475 28.6174 20.0001 28.4328 20 28.2444V4.15821C20.0001 3.96985 19.9475 3.78525 19.848 3.62552C19.7485 3.46579 19.6063 3.33738 19.4375 3.25497Z"
            // fill="#1C1C1C"
            fill="rgba(155, 155, 155, 1)"
          ></path>
          <path
            d="M24 12.187C23.7348 12.187 23.4804 12.2927 23.2929 12.4809C23.1054 12.6691 23 12.9244 23 13.1905V19.2121C23 19.4783 23.1054 19.7335 23.2929 19.9218C23.4804 20.11 23.7348 20.2157 24 20.2157C24.2652 20.2157 24.5196 20.11 24.7071 19.9218C24.8946 19.7335 25 19.4783 25 19.2121V13.1905C25 12.9244 24.8946 12.6691 24.7071 12.4809C24.5196 12.2927 24.2652 12.187 24 12.187Z"
            // fill="#1C1C1C"
            fill="rgba(155, 155, 155, 1)"
          ></path>
          <path
            d="M28 10.1798C27.7348 10.1798 27.4804 10.2855 27.2929 10.4737C27.1054 10.6619 27 10.9172 27 11.1834V21.2193C27 21.4855 27.1054 21.7407 27.2929 21.9289C27.4804 22.1172 27.7348 22.2229 28 22.2229C28.2652 22.2229 28.5196 22.1172 28.7071 21.9289C28.8946 21.7407 29 21.4855 29 21.2193V11.1834C29 10.9172 28.8946 10.6619 28.7071 10.4737C28.5196 10.2855 28.2652 10.1798 28 10.1798Z"
            // fill="#1C1C1C"
            fill="rgba(155, 155, 155, 1)"
          ></path>
        </g>
      </g>
    </svg>
  );
}
